import React from 'react';
import DateInput from '../../../common/DateInput.jsx';
import { cloneDeep } from 'lodash';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import DashboardIconSelect from '../../../common/icon_select/DashboardIconSelect.lazy.jsx';
import styles from './TimelineWidgetSettingsRow.module.scss';

function TimelineWidgetSettingsRow({
    d,
    datasets,
    index,
    datasetsKey,
    widgetId
}) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    
    const updateDatasetSetting = (key, index, value) => {
            const currentDatasets = cloneDeep(datasets)
            let dataset = {...datasets[index]};
            dataset[key] = value
            currentDatasets[index] = dataset;
            setAttribute(`settings.${datasetsKey}`, currentDatasets);
        };
    return (
        <>
            <div className="row">
            <label className={`col-xs-12 ${styles['date-picker-container']}`}>
                {I18n.t("date")}
                <DateInput defaultValue={d.date} onChange={(val) => updateDatasetSetting("date", index, val)} pickerOptions={{static: true}} />
            </label>
            <label className="col-xs-12">
                {I18n.t("value")}
                <input
                type="text"
                className="form-control"
                name="value"
                data-index={index}
                value={d.value}
                onChange={(e) => updateDatasetSetting("value", e.target.dataset.index, e.target.value)}
                />
            </label>
            <label className="col-xs-12">
                {I18n.t("label")}
                <input
                type="text"
                className="form-control"
                name="label"
                data-index={index}
                value={d.label}
                onChange={(e) => updateDatasetSetting("label", e.target.dataset.index, e.target.value)}
                />
            </label>
            <label className="col-xs-12">
                <div style={{ width: "20%", paddingLeft: "0", marginTop: "1rem", display: "inline-block" }}>{I18n.t("image")}</div>
                <DashboardIconSelect
                    value={d.image}
                    onChange={(v) => updateDatasetSetting('image', index, v)}
                />
            </label>
            <label className="col-xs-12">
                {I18n.t("subtitle")}
                <input
                type="text"
                className="form-control"
                name="subtitle"
                data-index={index}
                value={d.subtitle}
                onChange={(e) => updateDatasetSetting("subtitle", e.target.dataset.index, e.target.value)}
                />
            </label>
            </div>
        </>
    )
}

export default TimelineWidgetSettingsRow;
